import { render, staticRenderFns } from "./HalamanAwal.vue?vue&type=template&id=28fd271c"
import script from "./HalamanAwal.vue?vue&type=script&lang=js"
export * from "./HalamanAwal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports